import { render, staticRenderFns } from "./index.vue?vue&type=template&id=34aef362&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34aef362')) {
      api.createRecord('34aef362', component.options)
    } else {
      api.reload('34aef362', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=34aef362&", function () {
      api.rerender('34aef362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/index.vue"
export default component.exports